import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../../helpers/axiosInstance";
import { useNavigate } from "react-router-dom"; // Use useNavigate for navigation in React Router v6+
import { Container } from "reactstrap";

const ListBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate(); // Hook for navigation

    const fetchBlogs = async () => {
        try {
            const response = await axiosInstance.get(`/api/v1/blogs`);
            setBlogs(response.data);
            setLoading(false);
        } catch (error) {
            toast.error("Failed to load blogs");
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    const deleteBlog = async (id) => {
        try {
            await axiosInstance.delete(`/api/v1/admin/blog/${id}`);
            toast.success("Blog deleted successfully");
            fetchBlogs();
        } catch (error) {
            console.error("Failed to delete blog", error);
            toast.error("Failed to delete blog");
        }
    };

    const editBlog = (id) => {
        navigate(`/blogs/edit/${id}`); 
    };

    const createNewBlog = () => {
        navigate("/blogs-create"); 
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                            <h1 style={{ fontSize: "28px", fontWeight: "bold", textAlign: "center" }}>Admin - Manage Blogs</h1>
                            <button
                                onClick={createNewBlog}
                                style={{
                                    backgroundColor: "#28a745",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "8px",
                                    padding: "12px 20px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                Create New
                            </button>
                        </div>

                        {loading ? (
                            <div style={{ textAlign: "center", padding: "40px" }}>
                                <h3>Loading blogs...</h3>
                            </div>
                        ) : (
                            <div className="blog-container" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" }}>
                                {blogs.map((blog) => (
                                    <div
                                        key={blog._id}
                                        className="blog-card"
                                        style={{
                                            border: "1px solid #ddd",
                                            borderRadius: "12px",
                                            padding: "16px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            backgroundColor: "#fff",
                                            display: "flex",
                                            flexDirection: "column",
                                            transition: "transform 0.3s",
                                        }}
                                    >
                                        <img
                                            src={blog.coverImage.startsWith("https") ? blog.coverImage : `${process.env.REACT_APP_BASEURL}${blog.coverImage}`}
                                            alt={blog.title}
                                            height={200}
                                            width={300}
                                            style={{
                                                borderRadius: "12px",
                                                objectFit: "cover",
                                                marginBottom: "12px",
                                            }}
                                        />
                                        <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px" }}>{blog.title}</h2>
                                        <p style={{ fontSize: "14px", color: "#555", marginBottom: "12px" }}>Author: {blog.author}</p>
                                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                            <button
                                                onClick={() => editBlog(blog._id)}
                                                style={{
                                                    padding: "10px 16px",
                                                    backgroundColor: "#007BFF",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    width: "30%",
                                                }}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => deleteBlog(blog._id)}
                                                style={{
                                                    padding: "10px 16px",
                                                    backgroundColor: "#f44336",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    width: "30%",
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ListBlogs;
